<!--
  ~ Copyright © 2018 DV Bern AG, Switzerland
  ~
  ~ Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
  ~ geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
  ~ insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
  ~ elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
  ~ Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
  -->

@if (show$ | async) {
    @if (isMainBar) {
    <button mat-raised-button
            #exportButton
            i18n-matTooltip="@@xml-export.xml-export-header.tooltip"
            matTooltip="Alle Daten in eine XML-Datei exportieren"
            color="primary"
            class="elohn-xml-export-button"
            (click)="handleExport()">
        <span i18n="@@xml-export.xml-export-header">
            <mat-icon>save_alt</mat-icon>
            Daten speichern
        </span>
    </button>
    } @else {

        <button mat-raised-button
                i18n-matTooltip="@@xml-export.xml-export.tooltip"
                matTooltip="Alle Daten in eine XML-Datei exportieren"
                cdkFocusInitial
                color="primary"
                i18n="@@xml-export.xml-export"
                (click)="handleExport()">
            <mat-icon>save_alt</mat-icon>
            erfasste Daten speichern
        </button>
    }

}